import { UserResponseModel } from "../../models";
import { getUser } from "./secureManager";

export const isUserCurrentBranchAssigned = (): boolean => {
    const user: UserResponseModel | null = getUser();
    return !user?.IsMultiBranch || (user?.currentBranchId != null && user?.currentBranchId > 0);
}

/**
 * Checks if branch selection should be shown to the user.
 * Returns true if user is multi-branch enabled AND has not selected a branch yet.
 * Once a branch is selected, this will return false and won't show the selection again.
 */
export const shouldShowBranchSelection = (): boolean => {
    const user: UserResponseModel | null = getUser();
    // Show selection only if multi-branch is enabled AND currentBranchId is not set
    return !!(user?.IsMultiBranch && (user?.currentBranchId == null || user?.currentBranchId === 0));
}
export const getUserCurrentBranchId = (): number | null => {
    const user: UserResponseModel | null = getUser();
    return user?.currentBranchId !== undefined ? user.currentBranchId : null;
};
export const getUserBranchId = (): number | null => {
    const user: UserResponseModel | null = getUser();
    return user?.BranchID !== undefined ? user.BranchID : null;
};
export const getUserDefaultBranchId = (): number | null => {
    const user: UserResponseModel | null = getUser();
    return user?.currentBranchId ?? user?.BranchID ?? null;
}
